import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import Translate from 'modules/local/Translate'
import React, {useContext} from 'react'
import {GiIronCross} from 'react-icons/gi'
import {NullAsDefault} from 'views/Shared'
import {renderElse, renderIf, renderIfElse} from '../../../Shared'
import {PiArrowFatLineRightFill} from "react-icons/pi";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import {Popover} from "antd";
import {GoDotFill} from "react-icons/go";
import {DoubleValueItem} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import {renderDayOfWeek} from "../../../AppLocals/Church/functions/renderDayOfWeek";
import {formatDate, parseDayjs, renderFromToTime} from "../../../../helpers/datetimeHelpers";
import useTranslate from "../../../../modules/local/useTranslate";
import dayjs from "dayjs";

const Dates = ({to_date, from_date}) => {
    const t = useTranslate()
    let one_day = formatDate(from_date, 'DD/MM/YYYY') === formatDate(to_date, 'DD/MM/YYYY')

    return (
        renderIfElse(
            one_day,
            <div className="font-bold text-sm text-color-300 tracking-wider leading-tight">
                {`${t('date')} `} {formatDate(from_date || to_date, 'DD/MM/YYYY')}
            </div>,
            <div className="font-bold text-sm text-color-300 tracking-wider leading-tight">
                {renderFromToTime(from_date, to_date)}
            </div>
        )
    )
}


export const renderCourseClassTimetableWithMilestone = ({renderContextMenu = NullAsDefault, displayAll = true} = {}) => (item, index) => {
    const {isSm} = useContext(LayoutContext)
    const isHappened = parseDayjs(item?.to_date)?.isBefore(dayjs())
    const isMileStone = !!item?.is_milestone

    const renderTime = (time) => (
        dayjs(time, "HH:mm:ss").format("HH:mm")
    )

    const {subject, teacher, notes, from_date, to_date, from_time, to_time, location_address, attendances = [], days_of_week, is_holiday} = item ?? {}

    if (!!!displayAll && isHappened) return null;

    return (
        <Translate key={index}>
            {(t) =>
                renderIfElse(
                    isMileStone,
                    <div className={classNames('flex', !isSm && 'flex-center', isHappened && 'opacity-35')}>
                        <div className="flex items-center gap-3 leading-tight">
                            <div
                                style={{marginLeft: -3}}
                                className="flex flex-center">
                                <PiArrowFatLineRightFill size={18} className="timeline-icon text-green-300"/>
                            </div>
                            <div className="space-x-2 font-bold text-2xl text-green-700 uppercase italic">
                                {renderElse(
                                    item?.phase_title,
                                    <span>{t('phase')}</span>
                                )}
                                <span>{item?.phase_nbr}</span>
                                {renderIf(
                                    item?.phase_title,
                                    <span>{'. '}{item?.phase_title}</span>
                                )}
                            </div>
                        </div>
                    </div>,
                    <div className={classNames('flex justify-between gap-2', isHappened && 'opacity-35')}>
                        <div
                            style={{gap: isSm ? '0.6rem' : '1rem', gridGap: isSm ? '0.6rem' : '1rem'}}
                            className={
                                classNames(
                                    'w-full create-my-timeline',
                                    item?.phase_nbr === 0 ?
                                        ((index % 2 === 0 && !isSm) ? 'flex-row-reverse text-right 11-11' : 'flex-row 11-11') :
                                        (item?.phase_nbr % 2 === 0 && !isSm) ? 'flex-row-reverse text-right 22-22' : 'flex-row  22-22'
                                )
                            }>
                            {renderElse(
                                isSm,
                                <div className="flex-1"/>
                            )}
                            <div
                                style={{width: 10, marginTop: 4}}
                                className="flex flex-col gap-1 flex-center">
                                <GiIronCross
                                    size={9}
                                    style={{
                                        color: isHappened
                                            ? 'var(--text-color-100)'
                                            : 'var(--color-primary-600)',
                                    }}
                                    className="timeline-icon"
                                />
                                <div className="timeline-tail flex-1 h-full"/>
                            </div>
                            <div className="flex flex-col flex-1">
                                <Dates from_date={from_date} to_date={to_date}/>
                                <div className="flex flex-col leading-snug mt-1">
                                    {renderIfElse(
                                        is_holiday === 1,
                                        <div className="space-x-1">
                                            <PiArrowFatLineRightFill size={11} className="text-primary-300"/>
                                            <span
                                                className="font-medium text-sm text-primary-400 italic tracking-widest">
                                            {t('holiday')}
                                        </span>
                                        </div>,
                                        <DoubleValueItem
                                            showIcon={true}
                                            primary={true}
                                            labelFirst="time"
                                            valueFirst={`${renderTime(from_time)} - ${renderTime(to_time)}`}
                                            labelSecond=", "
                                            valueSecond={renderDayOfWeek(days_of_week)}
                                            className="text-xs italic"
                                        />
                                    )}

                                    {renderIf(
                                        is_holiday === 0 && location_address,
                                        <ItemInformation primary={true} label="in" value={location_address}
                                                         className="ml-3 text-xs italic"/>
                                    )}
                                </div>
                                {renderIf(
                                    is_holiday === 0 && subject,
                                    <span className="ml-1 font-bold text-base md:text-lg text-blue-600 mt-1">
                                    {getTitle(subject)}
                                </span>
                                )}
                                {renderIf(
                                    is_holiday === 0 && teacher,
                                    <ItemInformation showIcon={true} label="teacher" value={getTitle(teacher)}
                                                     className="text-xs italic leading-tight"/>
                                )}
                                {renderIf(
                                    notes,
                                    <div className={classNames(
                                        "flex gap-1 text-xs italic",
                                        item?.phase_nbr === 0 ?
                                            (index % 2 === 0 && !isSm) ? 'justify-end' : 'justify-start' :
                                            (item?.phase_nbr % 2 === 0 && !isSm) ? 'justify-end' : 'justify-start'
                                    )}>
                                    <span className="space-x-1 text-color-500 whitespace-no-wrap">
                                        <GoDotFill size={10} className="text-color-500"/>
                                        {`${t('note')} : `}
                                    </span>
                                        <span className="font-semibold text-color-100 whitespace-pre-line">
                                        {notes}
                                    </span>
                                    </div>
                                )}
                                {renderIf(
                                    attendances.length,
                                    <Popover
                                        title={
                                            <span
                                                className="font-bold text-sm text-color-000">{t('list of lesson')}</span>
                                        }
                                        content={
                                            <div className="flex flex-col gap-1 m-2">
                                                {attendances.map((e, i) => (
                                                    <div key={i} className="flex items-center gap-6 italic">
                                  <span className="font-medium text-sm text-color-100">
                                      {`${i + 1}. ${e.title}`}
                                  </span>
                                                        <span className="font-medium text-xs text-color-100">
                                      <span className="font-normal text-color-400">
                                          {`${t('in attendance')} : `}
                                      </span>
                                                            {`${e.total_attendance}/${e.total_students}`}
                                  </span>
                                                        {renderIf(
                                                            (e.total_excused_absence + e.total_unexcused_absence) > 0,
                                                            <span
                                                                className="font-medium text-xs text-color-100">
                                          <span
                                              className="font-normal text-color-400">{`${t('absence')} : `}</span>
                                                                {e.total_excused_absence + e.total_unexcused_absence}
                                      </span>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>
                                        }>
                                        <div
                                            className="flex items-center gap-1 font-medium text-xs text-color-400 hover:text-color-100 italic cursor-pointer">
                                            <GoDotFill size={10}/> {t('attendance sheet')}
                                        </div>
                                    </Popover>
                                )}
                            </div>
                        </div>
                        {renderContextMenu(item)}
                    </div>
                )
            }
        </Translate>
    )
}
